export default "__VITE_ASSET__276a250d__"